// extracted by mini-css-extract-plugin
export default {"root":"_2-70itbuF1","header":"JKE-0c5hxF","icon":"o2VhY_cs6Z","body":"_3QDGxJ_pWs","hostnamePort":"tTZzzcEsTA","error":"_2cCgtjpQZP","footer":"_3OT00Mqmrw"};